import Vue from 'vue';
import { getStoreBuilder, BareActionContext } from 'vuex-typex';

// === STATE - Prepare initial state, store builder
export const initialConstantsState: IConstantsStore = {
	defaultPartnerId: "Default",
	rsiPrefix: "RSI-",
	rsiOfficeIds: [ "a1lG0000002JbOxIAK", "a1l1L00000D6C3xQAF", "a1l1L00000D6C3yQAF", "a1l1600000D2habAAB", "a1l16000009fJfGAAU", "a1l1L00000DPU1jQAH", "a1l1600000DIBH1AAP", "a1l1600000CnBY8AAN" ],
	dsiPrefix: "DSI-",
	dsiOfficeIds: [ "a1l16000009eXd9AAE", "a1l1L00000DPU4sQAH", "a1l16000009fJfHAAU" ]
};

export const adminUserPartner: IPartner = {
	id: "",
	team: "",
	settings: {}
}

// Prepare store builder for use throughout
const storeBuilder = getStoreBuilder<IRootStore>();
const moduleBuilder = storeBuilder.module<IConstantsStore>(
	'constants',
	initialConstantsState,
);

// === GETTERS - Like computed data or used to get a part of the data or return it in a specific way and cache it

// === MUTATIONS - Synchronous work that mutates the data store. Should be quick
interface IConstantsMutationParams {
	which: string;
	value: any;
}
const SET_CONSTANTS_MUTATION = (
	state: IConstantsStore,
	data: IConstantsMutationParams,
) => {
	Vue.set(state, data.which, data.value); // For reactivity
};

// === ACTIONS - Asynchronous work that gets data, changes the data for storage, and handles errors.
const OVERRIDE_CONSTANTS_ACTION = (
	{}: BareActionContext<IConstantsStore, IRootStore>,
	constants: {}
): Promise<any> => {
	for (const [key, value] of Object.entries(constants)) {
		constantsStore.commitSetConstants({ which: key, value: value });
	}
	return Promise.resolve(constants);
};

// === EXPORTS - Modules state or storage handling. Gets combined with the root store on compile or run.
// Prepare this module's state for export
const stateGetter = moduleBuilder.state();

// exported module interface
const constantsStore = {
	// state
	get state() { return stateGetter(); },

	// getters

	// mutations
	commitSetConstants: moduleBuilder.commit(SET_CONSTANTS_MUTATION, 'SET_ConstantS'),

	// action
	dispatchOverrideConstants: moduleBuilder.dispatch(
		OVERRIDE_CONSTANTS_ACTION,
		'overrideConstants',
	),
};

// Export default store object
export default constantsStore;
